import { Board, ShipmentPart } from "../../../reducers/uploadedBoard";
import {
  DetailsContainer,
  PartList,
  StatusTableCell,
  SubTitle,
  Title,
  VerticalList,
} from "./BoardInventoryStyles";
import React from "react";
import {
  FlashPCBTable,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../constants/Styles";
import { Container } from "../../../reducers/componentSearch";
import { FeederStatus } from "../../../utils/hooks/inventory/boardInventory";
import { TrayPartsWarning } from "../BoardFiles/PanelDetails";

const ContainerDetailTable = ({
  containersToDisplay,
}: {
  containersToDisplay: Container[];
}) => {
  return (
    <FlashPCBTable>
      <thead>
        <TableHeaderRow>
          <TableHeaderCell>Part</TableHeaderCell>
          <TableHeaderCell>Container</TableHeaderCell>
          <TableHeaderCell>Reel width</TableHeaderCell>
          <TableHeaderCell>Current bin name</TableHeaderCell>
          <TableHeaderCell>Current bin location</TableHeaderCell>
          <TableHeaderCell>Current bin barcode</TableHeaderCell>
        </TableHeaderRow>
      </thead>
      <tbody>
        {containersToDisplay.map((container) => (
          <TableRow key={container.flashpcb_container_barcode}>
            <StatusTableCell>{container.part_name}</StatusTableCell>
            <StatusTableCell>
              {container.flashpcb_container_barcode}
            </StatusTableCell>
            <StatusTableCell>
              {container.reel_width_mm ? `${container.reel_width_mm} mm` : "-"}
            </StatusTableCell>
            <StatusTableCell>{container.bin_name}</StatusTableCell>
            <StatusTableCell>{container.bin_location}</StatusTableCell>
            <StatusTableCell>{container.flashpcb_bin_barcode}</StatusTableCell>
          </TableRow>
        ))}
      </tbody>
    </FlashPCBTable>
  );
};

export default function ContainersOnFeedersStatusDetails({
  board,
  shipmentParts,
  containersNeededOnFeeders,
}: {
  board: Board;
  shipmentParts: ShipmentPart[];
  containersNeededOnFeeders: FeederStatus;
}) {
  return (
    <>
      <Title>{board.project_name}</Title>
      <DetailsContainer>
        <TrayPartsWarning shipmentParts={shipmentParts} />
        <SubTitle>Parts not SMT ready</SubTitle>
        {containersNeededOnFeeders.parts_not_smt_ready.length > 0 ? (
          <VerticalList>
            <PartList>
              {containersNeededOnFeeders.parts_not_smt_ready.map((part) => (
                <li key={part}>{part}</li>
              ))}
            </PartList>
          </VerticalList>
        ) : (
          <div>None</div>
        )}
        {Object.entries(containersNeededOnFeeders.feeders_still_needed).length >
        0 ? (
          <>
            <SubTitle>Feeders needed to pull:</SubTitle>
            <VerticalList>
              <PartList>
                {Object.entries(
                  containersNeededOnFeeders.feeders_still_needed,
                ).map(([width, count]) => (
                  <li key={width}>
                    {width} feeders still needed: {count}
                  </li>
                ))}
              </PartList>
            </VerticalList>
          </>
        ) : (
          <div>None</div>
        )}
      </DetailsContainer>

      <DetailsContainer>
        <SubTitle>
          Allocated containers that are still in general inventory
        </SubTitle>
        {containersNeededOnFeeders.containers_not_on_feeders_or_in_tote.length >
        0 ? (
          <ContainerDetailTable
            containersToDisplay={
              containersNeededOnFeeders.containers_not_on_feeders_or_in_tote
            }
          />
        ) : (
          <div>None</div>
        )}
      </DetailsContainer>

      <DetailsContainer>
        <SubTitle>Allocated containers that are in the board tote</SubTitle>
        {containersNeededOnFeeders.containers_in_board_tote.length > 0 ? (
          <ContainerDetailTable
            containersToDisplay={
              containersNeededOnFeeders.containers_in_board_tote
            }
          />
        ) : (
          <div>None</div>
        )}
      </DetailsContainer>

      <DetailsContainer>
        <SubTitle>Allocated containers currently on feeders</SubTitle>
        {containersNeededOnFeeders.containers_on_feeders.length > 0 ? (
          <ContainerDetailTable
            containersToDisplay={
              containersNeededOnFeeders.containers_on_feeders
            }
          />
        ) : (
          <div>None</div>
        )}
      </DetailsContainer>
    </>
  );
}
